import React from 'react';
import { IconRightArrow, IconCirclePlus } from 'src/content/icons';
import { Button } from '@framework-controls/core';
import css from './SVPButton.module.scss';
import classNames from 'classnames';

export interface IProps {
    id: string;
    message: React.ReactNode;
    variant?: string | 'primaryBtn';
    noArrow?: boolean;
    plus?: boolean;
    backArrow?: boolean;
    isDisabled?: boolean;
    handler: (e: any) => void;
    tooltip?: string;
    longLitFlag?: string;
    theme?: string;
}

const SVPButton = (props: IProps) => {
    let btnLitClasses = [css.btnLit];

    if (props.theme === 'acura-CA' && props.id !== 'Add') {
        btnLitClasses.push(css.btnLitAcura);
    }

    if (props.theme === 'chevrolet' && props.id === 'Add') {
        btnLitClasses.push(css.btnLitCV);
    }

    if (props.theme === 'bmw' && props.id === 'Add') {
        btnLitClasses.push(css.btnLitBMW);
    }

    if (props.theme === 'mazda') {
        btnLitClasses.push(css.btnLitMazda);
    }

    if (props.theme === 'genesis'){
        btnLitClasses.push(css.btnLitGenesis);
    }

    const arrowStyles = classNames(
        css.arrowIcon,
        {
            [css.backArrowIcon]: props.backArrow,
            [css.arrowIconLM]: props.theme === 'lexusMonogram',
            [css.arrowIconCV]: props.theme === 'chevrolet',
            [css.arrowIconBMW]: props.theme === 'bmw',
            [css.arrowIconNissan]: props.theme === 'nissan',
            [css.arrowIconMazda]: props.theme === 'mazda',
            [css.arrowIconGenesis]: props.theme === 'genesis',
        },
    );

    // by default set arrowDiv to null, but set so a ReactElement is a valid value for the var.
    let arrowDiv: React.ReactElement | null = null;
    // by default set backArrowDiv to null, but set so a ReactElement is a valid value for the var.
    let backArrowDiv: React.ReactElement | null = null;
    // if not noArrow (false), and if backArrow (true) then build the backArrowDiv reactElement
    // otherwise build the normal forwards arrow, arrovDiv reactElement.
    if (!props.noArrow) {
        if (props.backArrow) {
            backArrowDiv = (
                <div className={arrowStyles}>
                    <IconRightArrow style={{ margin: 'auto' }} />
                </div>);
        } else {
            arrowDiv = (
                <div className={arrowStyles}>
                    <IconRightArrow style={{ margin: 'auto' }} />
                </div>);
        }
    }
    // by default set plusDiv to null, but set so a reactElement is valid value for the var.
    let plusDiv: React.ReactElement | null = null;
    // if plus is true, then build the plusDiv reactElement.
    if (props.plus) {
        plusDiv = (
            <div className={css.plusIcon}>
                <IconCirclePlus style={{ margin: 'auto' }} />
            </div>
        );
    }

    // For mobile we need to add a margin if the button contains a back arrow or plus sign
    if (props.plus || props.backArrow) {
        btnLitClasses.push(css.btnLitOneIcon);
    }
    // if plus and not noArrow, then add a css prop to support both icons.
    if (props.plus && !props.noArrow) {
        btnLitClasses.push(css.btnLitBothIcons);
    }
    // set button variant based on passed in prop.
    // If nothing passed in, then default to primaryBtn
    let btnVariant = props.variant;
    if (!btnVariant) {
        btnVariant = 'primaryBtn';
    }
    if (btnVariant === 'MFABtn') {
        btnLitClasses = [css.btnLitMFA];
    }

    let btnToolTip = '';
    if (!props.isDisabled) {
        btnToolTip = props.tooltip ? props.tooltip : '';
    }

    // Long literals require different rems.
    if (props.longLitFlag) {
        switch (props.longLitFlag) {
            case 'A': btnLitClasses.push(css.longLitA);
                break;
            case 'B': btnLitClasses.push(css.longLitB);
                break;
            default: btnLitClasses.push(css.longLitA);
        }
    }

    return (
        <Button
            id={props.id + 'btn'}
            variant={btnVariant}
            type={'custom'}
            disabled={props.isDisabled}
            onClick={props.handler}
            // tooltip={!props.isDisabled ? props.tooltip : ''}
            tooltip={btnToolTip}
        >
            {plusDiv}
            {backArrowDiv}
            <div
                className={btnLitClasses.join(' ')}>{props.message}</div>
            {arrowDiv}
        </Button>
    );
};

export default SVPButton;
